// Transform block tree state action to block server api
const BlockActionTransformer = (origin) => {

    const data = { ...origin };
    
    return data
}

export default BlockActionTransformer;